export default __webpack_public_path__ + "static/media/diamond-black-friday.1a353e5d.png";